import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ClientDashboardComponent } from './pages/dashboard/client-dashboard/client-dashboard.component';
import { AdminDashboardComponent } from './pages/dashboard/admin-dashboard/admin-dashboard.component';
import { WebusersComponent } from './pages/administration/webusers/webusers.component';
import { WebusersManageComponent } from './pages/administration/webusers/webusers-manage/webusers-manage.component';
import { ROTEReportsComponent } from './pages/reports/rote/rote-reports.component';
import { AssetRegisterComponent } from './pages/reports/asset-register/asset-register.component';
import { AssetManagementComponent } from './pages/administration/asset-management/asset-management.component';
import { AssetManageComponent } from './pages/administration/asset-management/asset-manage/asset-manage.component';
import { JobManageComponent } from './pages/administration/job-management/job-manage/job-manage.component';
import { JobManagementComponent } from './pages/administration/job-management/job-management.component';
import { JobReportComponent } from './pages/reports/job-reports/job-reports.component';
import { EngineersManageComponent } from './pages/administration/engineers/engineers-manage/engineers-manage.component';
import { EngineerComponent } from './pages/administration/engineers/engineers.component';
import { CompanyOverviewComponent } from './pages/administration/companies/overview/company-overview.component';
import { CompanyManageComponent } from './pages/administration/companies/management/company-mange.component';
import { IndividualInspectionComponent } from './pages/administration/inspections/individual-inspections/individual-inspections.component';
import { UserDashboardComponent } from './pages/dashboard/user-dashboard/user-dashboard.component';
import { LocationComponent } from './pages/administration/locations/locations.component';
import { LocationsManageComponent } from './pages/administration/locations/locations-manage/locations-manage.component';
import { SublocationComponent } from './pages/administration/sublocations/sublocations.component';
import { UploadAssetComponent } from './pages/administration/asset-management/upload/upload.component';
import { ImportInspectionComponent } from './pages/import/inspections/import-inspections.component';
import { LoginComponent } from './pages/login/login.component';



const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'dashboard', children: [
      { path: '', component: DashboardComponent },
      { path: 'admin', component: AdminDashboardComponent },
      { path: 'client', component: ClientDashboardComponent },
      { path: 'user', component: UserDashboardComponent }
      ]
  },
  {
    path: 'reports', children: [
      { path: '', component: ROTEReportsComponent },
      { path: 'rote', component: ROTEReportsComponent },
      { path: 'asset-register', component: AssetRegisterComponent },
      { path: 'job-reports', component: JobReportComponent }
    ]
  },
  {
    path: 'admin', children: [
      {
        path: 'assets', children: [
          { path: '', component: AssetManagementComponent },
          { path: 'upload', component: UploadAssetComponent },
          { path: 'manage', component: AssetManageComponent },
          { path: 'manage/:id', component: AssetManageComponent }
        ]
      },
      {
        path: 'inspect', children: [
          { path: 'individual', component: IndividualInspectionComponent },
          { path: 'bulk', component: IndividualInspectionComponent }
        ]
      },
      {
        path: 'locations', children: [
          { path: '', component: LocationComponent },
          { path: 'manage', component: LocationsManageComponent },
          { path: 'manage/:id', component: LocationsManageComponent },
        ]
      },
      {
        path: 'sublocations', children: [
          { path: '', component: SublocationComponent },
        ]
      },
      {
        path: 'companies', children: [
          { path: '', component: CompanyManageComponent },
          { path: 'manage', component: CompanyManageComponent },
          { path: 'manage/:id', component: CompanyManageComponent },

          { path: 'overview', component: CompanyOverviewComponent },
        ]
      },
    ]
  },

  {
    path: 'import', children: [
      { path: 'inspections', component: ImportInspectionComponent },
    ]
  },{
    path: 'users', children: [
      { path: '', component: WebusersComponent },
      { path: 'manage', component: WebusersManageComponent },
      { path: 'manage/:id', component: WebusersManageComponent }
    ]
  },
  {
    path: 'engineers', children: [
      { path: '', component: EngineerComponent },
      { path: 'manage', component: EngineersManageComponent },
      { path: 'manage/:id', component: EngineersManageComponent }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
